import { Toaster as Sonner, toast, type ToasterProps } from 'sonner'

/**
 * 토스트.
 *
 * 🔴 Silent Success, Loud Failure — 성공은 1.5초쯤 짧게 지나가고, 실패는
 *    사용자가 닫을 때까지 남습니다. 실패가 저절로 사라지면 무엇이 잘못됐는지
 *    모른 채 다음 작업으로 넘어가게 됩니다.
 *
 * 앱은 다크 테마 전용이므로 theme 을 고정합니다.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      closeButton
      richColors
      duration={2000}
      toastOptions={{
        classNames: {
          toast:
            'group border-border bg-card text-card-foreground shadow-lg text-sm whitespace-pre-line',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-secondary text-secondary-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
